<template>
  <div class="settings">
    <div class="setting-header-cal">
      <div class="left-dropdown-business">
        <div class="title-setting-header"><span>โหมดการคำนวณอิงเงื่อนไขแบบง่าย</span></div>
      </div>
      <div class="right-dropdown-business">
        <div class="title-dropdown-business"><span>ประเภทธุรกิจ</span></div>
        <div class="dropdown-business">
          <v-select
            v-model="businessTypeSelect"
            placeholder="กรุณาเลือกประเภทธุรกิจ"
            :options="dropDownBusinessTypeSelect"
            :clearable="false"
            :searchable="false"
          ></v-select>
        </div>
      </div>
    </div>
    <div class="dividerx" />
    <div class="setting-row">
      <div class="left-setting-row">
        <span>Measurement</span>
        <div class="tooltip-question">
          <CommentBox class="title-question-icon" />
          <span class="tooltip-text">
            <div class="title">{{ 'Measurement' }}</div>
          </span>
        </div>
      </div>

      <div class="right-setting-row">
        <div class="right-text-setting-row">
          <span>Timeframe</span>
          <div class="tooltip-question">
            <CommentBox class="title-question-icon" />
            <span class="tooltip-text">
              <div class="title">{{ 'Timeframe' }}</div>
            </span>
          </div>
        </div>
        <div class="right-tab-setting-row">
          <div class="timeframe-links-container">
            <div class="timeframe-links">
              <div class="button-timeframe" :class="{ active: calculationTimeFrame == 'multi' }" @click="selectTimeFrame('multi')">
                Multi-Timeframe
              </div>
              <div class="button-timeframe" :class="{ active: calculationTimeFrame == 'single' }" @click="selectTimeFrame('single')">
                Single-Timeframe
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="calculationTimeFrame == 'single'" class="body-content-container-timeframe"><CalSingleTimeFrame /></div>
    <div v-else class="body-content-container-timeframe"><CalMultiTimeFrame /></div>
  </div>
</template>
<script setup lang="ts">
import { onBeforeMount, ref, Ref, markRaw } from 'vue';
import CalMultiTimeFrame from '@/views/modules/analytics/components/anal-churnrate/CalMultiTimeFrame.vue';
import CalSingleTimeFrame from '@/views/modules/analytics/components/anal-churnrate/CalSingleTimeFrame.vue';
import CommentBox from '@/assets/icons/modules/segment/all-segment/CommentBox.vue';

interface Measurement {
  name: string;
  enabled: boolean;
  value: number;
  timeframe: string;
  timeframeValue: number;
  timeframeUnit: string;
}

const calculationTimeFrame = ref<string>('multi');

const dropDownBusinessTypeSelect = ref<any[]>([
  { label: 'Food & Beverage', id: 0 },
  { label: 'Car Wash', id: 1 },
  { label: 'Nail & Salon', id: 2 },
  { label: 'Electronic', id: 3 },
  { label: 'Hotel Restaurant', id: 4 },
  { label: 'Retail', id: 5 },
]);

const businessTypeSelect = ref<any>(null);

function selectTimeFrame(type: string) {
  calculationTimeFrame.value = type;
}
</script>

<style lang="scss" scoped>
.title-question-icon {
  padding-left: 0.5rem;
  width: 25px;
  height: auto;
  fill: #707070;
  &:hover {
    fill: #000000;
  }
}
.tooltip-question {
  position: relative;
  display: inline-block;

  &:hover {
    .tooltip-text {
      visibility: visible;
    }
  }

  .tooltip-text {
    position: relative;
    visibility: hidden;
    background-color: #efefef;
    text-align: center;
    border-radius: 6px;
    padding: 1rem;
    max-width: 370px;
    width: max-content;

    /* Position the tooltip */
    position: absolute;
    z-index: 1;
    top: -5px;
    left: 40px;
    font-weight: 400;
    text-align: left;
    .title {
      font-size: 16px;
      color: #000000;
    }
    .detail {
      color: #707070;
    }

    &::after {
      content: '';
      position: absolute;
      left: -9px;
      top: 10px;
      width: 0px;
      height: 0px;

      border-right: 10px solid #efefef;
      border-bottom: 5px solid transparent;
      border-top: 5px solid transparent;
    }
  }
}
.settings {
  width: 100%;
  padding: 24px;
  gap: 24px;
  border-radius: 10px;
  background: #ffffff;
  margin-top: 1rem;
  margin-bottom: 6rem;
  .setting-header-cal {
    display: flex;
    justify-content: space-between;
    .left-dropdown-business {
      .title-setting-header {
        //styleName: H2;
        font-family: Prompt;
        font-size: 20px;
        font-weight: 500;
        line-height: 30.24px;
        text-align: left;
      }
    }
    .right-dropdown-business {
      display: flex;
      align-items: center;
      .title-dropdown-business {
        //styleName: SH1;
        font-family: Prompt;
        font-size: 16px;
        font-weight: 400;
        line-height: 24.19px;
        text-align: left;
      }
      .dropdown-business {
        margin-left: 1rem;
        font-family: Prompt;
        font-size: 16px;
        font-weight: 400;
        line-height: 1;
        text-align: left;
        color: #2d2d2d;
        display: block;
        width: 260px;
        background-color: #fff;
        background-clip: padding-box;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        transition:
          border-color 0.15s ease-in-out,
          box-shadow 0.15s ease-in-out;
        letter-spacing: 0.031rem;
        border-radius: 10px;

        ::placeholder {
          color: #b8b8b8;
        }
        &:deep(.vs__dropdown-toggle) {
          border: 1px solid #e2e2e2;
          border-radius: 10px;
          height: 42px;
        }

        .vs__selected-options {
          position: relative;
          height: 100%;
        }

        .v-select {
          width: 100%;

          .vs__dropdown-toggle {
            height: 100%;

            .vs__selected {
              position: absolute;
              height: 100%;
              margin: auto auto auto 0;
            }
          }
        }
      }
    }
  }
  .dividerx {
    margin-top: 1rem;
    margin-bottom: 1rem;
    width: 100%;
    height: 1px;
    background: #e2e2e2;
  }
  .setting-row {
    display: flex;
    width: 100%;
    justify-content: space-between;
    margin-bottom: 8px;
    font-weight: bold;
    span {
      margin-right: 1rem;
    }
    .left-setting-row {
      width: 50%;
      //styleName: H3;
      font-family: Prompt;
      font-size: 20px;
      font-weight: 400;
      line-height: 30.24px;
      text-align: left;
    }
    .right-setting-row {
      width: 50%;
      .right-text-setting-row {
        //styleName: H3;
        font-family: Prompt;
        font-size: 20px;
        font-weight: 400;
        line-height: 30.24px;
        text-align: left;
      }
      .right-tab-setting-row {
        .timeframe-links-container {
          display: flex;
          width: 100%;
          .timeframe-links {
            display: flex;
            padding: 10px;
            align-items: center;
            border-radius: 8px;
            background: #eee;
            margin-top: 1rem;
            .button-timeframe {
              display: flex;
              min-width: 80px;
              padding: 4px;
              justify-content: center;
              align-items: center;
              color: #929292;
              text-align: center;
              font-family: Prompt;
              font-size: 16px;
              font-style: normal;
              font-weight: 400;
              line-height: normal;

              cursor: pointer;

              &.active {
                display: flex;
                min-width: 80px;
                padding: 4px;
                justify-content: center;
                align-items: center;
                border-radius: 4.5px;
                background: #fff;
                color: #007fff;
                text-align: center;
                font-family: Prompt;
                font-size: 16px;
                font-style: normal;
                font-weight: 400;
                line-height: normal;
                /* Shadow/Shadow 02 */
                box-shadow:
                  0px 29px 8px 0px rgba(128, 128, 128, 0),
                  0px 18px 7px 0px rgba(128, 128, 128, 0.01),
                  0px 10px 6px 0px rgba(128, 128, 128, 0.05),
                  0px 5px 5px 0px rgba(128, 128, 128, 0.09),
                  0px 1px 3px 0px rgba(128, 128, 128, 0.1);
              }
            }
          }
        }
      }
    }
  }

  .measurement-group {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;

    .setting-item {
      display: flex;
      align-items: center;
      gap: 8px;

      label {
        display: flex;
        align-items: center;
        gap: 8px;
      }

      input[type='number'] {
        width: 80px;
      }
    }
  }
}
</style>
